import Constants from "../utils/consts";
import Cookies from "universal-cookie";

const REQUEST_TIMEOUT = 600000; // 10 minuti

function getDbName() {
  try {
    return new Cookies().get("db", { path: "/" });
  } catch (error) {
    console.warn("[sendCompiti] Impossibile leggere il cookie db:", error);
    return undefined;
  }
}

export default async function sendCompiti(
  uname,
  token,
  corso,
  titolo,
  descrizione,
  data,
  file,
  userId,
  onProgress
) {
  return new Promise((resolve, reject) => {
    const db = getDbName();
    const endpoint = `${Constants.mainUrl}sendCompiti.php`;

    const xhr = new XMLHttpRequest();
    xhr.timeout = REQUEST_TIMEOUT;

    // Progress tracking
    xhr.upload.onprogress = function(event) {
      if (event.lengthComputable && onProgress) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        onProgress(percentComplete);
      }
    };

    xhr.onload = function() {
      console.log("[sendCompiti] response status:", xhr.status);
      console.log("[sendCompiti] response body:", xhr.responseText);

      if (xhr.status === 200) {
        try {
          const response = JSON.parse(xhr.responseText);
          resolve(response);
        } catch (error) {
          console.error("[sendCompiti] Error parsing response:", error);
          resolve(undefined);
        }
      } else {
        reject({
          error: "HTTP_ERROR",
          status: xhr.status,
          message: "Errore dal server durante il caricamento",
          details: xhr.responseText,
        });
      }
    };

    xhr.onerror = function(event) {
      console.error("[sendCompiti] network error:", event);
      reject({
        error: "NETWORK_ERROR",
        message: "Errore di rete durante l'upload",
      });
    };

    xhr.ontimeout = function() {
      console.error("[sendCompiti] timeout");
      reject({
        error: "TIMEOUT",
        message:
          "Il caricamento del compito ha richiesto troppo tempo. Riprova più tardi.",
      });
    };

    xhr.onabort = function() {
      console.warn("[sendCompiti] upload abortito");
      reject({
        error: "ABORTED",
        message: "Upload annullato",
      });
    };

    const params = new URLSearchParams();
    params.append("token", token);
    params.append("uname", uname);
    if (db) params.append("db_name", db);
    params.append("id_corso", corso);
    params.append("titolo", titolo);
    params.append("descrizione", descrizione);
    params.append("scadenza", data);
    params.append("filecontent", file || "");
    params.append("user_id", userId);

    const payload = params.toString();

    console.log("[sendCompiti] sending data:", {
      token: token ? "presente" : "mancante",
      uname: uname,
      id_corso: corso,
      titolo: titolo,
      descrizione: descrizione,
      scadenza: data,
      user_id: userId,
      filecontent: file ? "presente" : "mancante",
    });

    if (onProgress) {
      onProgress(0);
    }

    xhr.open("POST", endpoint, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(payload);
  });
}
